/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_GeschlechtInputs */

const en__field_geschlecht = /** @type {(inputs: _Field_GeschlechtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gender`)
};

const de__field_geschlecht = /** @type {(inputs: _Field_GeschlechtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschlecht`)
};

/**
* | output |
* | --- |
* | "Gender" |
*
* @param {_Field_GeschlechtInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_geschlecht = /** @type {((inputs?: _Field_GeschlechtInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_GeschlechtInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_geschlecht(inputs)
	return de__field_geschlecht(inputs)
});